import React from "react";

export default function FDServices() {
  const fdOffers = [
    { amount: 20000, duration: "5 Years", earnings: 12000, totalReceived: 32000 },
    { amount: 30000, duration: "5 Years", earnings: 18000, totalReceived: 48000 },
    { amount: 40000, duration: "5 Years", earnings: 24000, totalReceived: 64000 },
    { amount: 50000, duration: "5 Years", earnings: 30000, totalReceived: 80000 },
    { amount: 60000, duration: "5 Years", earnings: 36000, totalReceived: 96000 },
    { amount: 70000, duration: "5 Years", earnings: 42000, totalReceived: 112000 },
    { amount: 80000, duration: "5 Years", earnings: 48000, totalReceived: 128000 },
    { amount: 90000, duration: "5 Years",  earnings: 54000, totalReceived: 144000 },
    { amount: 100000, duration: "5 Years", earnings: 60000, totalReceived: 160000 },
  ];


  return (
    <div className="container mt-4">
      <p className="text-center text-danger fw-bold rounded p-2 shadow" style={{ maxWidth: "800px", background: "#d6d6d6", color: "#333", margin: "20px auto", fontSize: "16px", border: "2px solid #888", letterSpacing: "0.5px" }} >
        ⚠ *Note: If withdrawn before maturity, 20% of the total amount will be deducted.
      </p>
      <p>Secure your savings with high interest rates on FD schemes.</p>
      
      <table className="table table-striped text-center">
        <thead>
          <tr className="table-header">
            <th className="tab-header">Amount (₹)</th>
            <th className="tab-header">Duration</th>
            <th className="tab-header">Additional Earnings (₹)</th>
            <th className="tab-header">Total Amount Received (₹)</th>
          </tr>
        </thead>
        <tbody>
          {fdOffers.map((offer, index) => (
            <tr key={index}>
              <td>{offer.amount}</td>
              <td>{offer.duration}</td>
              <td>{offer.earnings}</td>
              <td>{offer.totalReceived}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
        
